import { totalStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


totalStyles.container = {
    gap: 10,
    css: css`
        background-color: ${getColor("common.accent")};
        padding: 20px;
        margin-top: 30px;
    `,

}